<template>
  <v-card>
    <v-card-title class="d-flex align-center justify-space-between">
      <div>
        <v-icon left>mdi-chart-bar</v-icon>
        Monthly Quotes by Channel
      </div>
    </v-card-title>
    <v-card-text>
      <div v-if="loading" class="text-center py-8">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
      <div v-else-if="!series.length" class="text-center py-8 text-medium-emphasis">
        No data available.
      </div>
      <div v-else>
        <apexchart
          type="bar"
          height="380"
          :options="chartOptions"
          :series="series"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import { statisticsService } from "../services";

export default {
  name: "QuotesByMonthChart",
  components: { apexchart: VueApexCharts },
  data() {
    return {
      loading: true,
      series: [],
      chartOptions: {
        chart: {
          id: "quotes-by-month",
          type: "bar",
          toolbar: { show: false },
          animations: { enabled: true },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 4,
            dataLabels: { position: "top" },
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: [],
          labels: { rotate: -35, rotateAlways: false },
        },
        yaxis: {
          decimalsInFloat: 0,
          labels: { formatter: (val) => Math.round(val) },
          title: { text: "Quotes" },
        },
        legend: { position: "top" },
        tooltip: {
          shared: true,
          intersect: false,
          y: { formatter: (val) => `${val} quotes` },
        },
        colors: [],
        fill: { opacity: 1 },
      },
    };
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const response = await statisticsService.getQuotesByMonth();
        if (response?.success && response?.data) {
          this.applyData(response.data);
        } else {
          this.series = [];
        }
      } catch (e) {
        console.error("Failed to load quotes by month", e);
        this.series = [];
      } finally {
        this.loading = false;
      }
    },
    applyData(data) {
      if (!data.months || !data.channels || !data.months.length) {
        this.series = [];
        return;
      }

      // Format month labels: "2025-08" → "Aug '25"
      const categories = data.months.map((m) => {
        const [year, month] = m.month.split("-");
        const date = new Date(parseInt(year), parseInt(month) - 1, 1);
        return date.toLocaleDateString("en-US", { month: "short", year: "2-digit" });
      });

      const colors = data.channels.map((ch) => ch.color || "#9E9E9E");

      const series = data.channels.map((ch) => ({
        name: ch.name,
        data: data.months.map((m) => m.channels[ch.id] || 0),
      }));

      this.series = series;
      this.chartOptions = {
        ...this.chartOptions,
        colors,
        xaxis: {
          ...this.chartOptions.xaxis,
          categories,
        },
      };
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.py-8 {
  padding-top: 32px;
  padding-bottom: 32px;
}
</style>
